module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/about/eco-concious/ECOCONS_02_hotelservice_01.png";